export default "__VITE_ASSET__DskkIqru__"